// Patch console.warn once to silence noisy [Vue Router warn] / test-only messages.
// This plugin is .client-only: it must never run on the SSR server, where re-wrapping
// the shared `console.warn` global on every request builds an unbounded chain of nested
// closures (each wrapper captures the previous one), leaking heap for the life of the
// process. The module-level `patched` guard is belt-and-suspenders so the patch is
// installed at most once even if the plugin is somehow invoked more than once.
let patched = false

export default defineNuxtPlugin(() => {
  if (patched) {
    return
  }
  patched = true

  const originalConsoleWarn = console.warn

  console.warn = (...args) => {
    const param = args[0]
    if (
      typeof param === 'string' &&
        args[0].includes('[Vue Router warn]:') ) {
      return
    }

    if (process.env.VITEST) {
      // testing pinia registration after pinia registration, all fine
      if ( param.includes('App already provides property with key "Symbol(pinia)') ) {
        return
      }
      // bug in nuxt/test-utils? check later
      if ( param.includes('Non-function value encountered for default slot. Prefer function slots for better performance') ) {
        return
      }
    }
    originalConsoleWarn.apply(console, args)
  }
})
